module.exports = __webpack_public_path__ + "img/wolf_family.54c7cf29.jpg";